import { Link } from "@/kit/ui/link";
import { useAuth, useLoginRedirect } from "@/utils/auth";
import { cn } from "@/utils/tailwind";
import { FormattedMessage, MessageDescriptor } from "react-intl";

export interface SignupCalloutProps {
  className?: string | undefined;
  title: MessageDescriptor;
  body: MessageDescriptor;
}

export default function SignupCallout({
  className,
  title,
  body,
}: SignupCalloutProps) {
  const loginPath = useLoginRedirect();
  const { userId } = useAuth();
  if (userId) {
    return null;
  }

  return (
    <div
      className={cn(
        className,
        "flex flex-col gap-2 p-4 rounded-lg border bg-grey-50",
      )}
    >
      <h4 className="font-semibold text-lg">
        <FormattedMessage {...title} />
      </h4>
      <p className="text-sm font-normal text-grey-600">
        <FormattedMessage {...body} />
      </p>
      <div className="flex flex-row justify-end flex-wrap mt-4 gap-2">
        <Link to={loginPath} variant="link">
          <FormattedMessage defaultMessage="Login" />
        </Link>
        <Link to="/signup" variant="primary">
          <FormattedMessage defaultMessage="Sign up" />
        </Link>
      </div>
    </div>
  );
}
